import { useLocation } from "react-router-dom";
import VendorsCard from "../../Components/Utilities/VendorsCard";
import { useTranslation } from "react-i18next";

export default function AllVendorsPage() {
    const location = useLocation();
     const { t } = useTranslation();

    console.log('location.state',location.state);

  return (
    <div>
        <VendorsCard customClasses={'flex-wrap gap-3'} title={t("All Vendors")}  />
    </div>
  )
}
